import {DataTable} from "../../../components";
import {
    pubmaticURLsBlacklistHead
} from "../../../constants/tableConstants";
import React, {useEffect} from "react";
import Request from '../../../services/Request'
import {pathFor} from "../../../constants/apiPaths";
import {useHistory} from "react-router-dom";

function PubmaticURLsBlacklist(props) {
    const history = useHistory();
    const {setMessageQueue} = props
    const [URLsBlacklist, setURLsBlacklist] = React.useState([])


    const fetchURLsBlacklist = async () => {
        try {
            const {statusCode, jsonResponse} = await Request(pathFor.pubmaticURLsBlacklist, {}, {}, "GET")
            if (statusCode === 200) {
                const {global_blacklist} = jsonResponse
                setURLsBlacklist(global_blacklist)
            } else if (statusCode === 401) {
                setMessageQueue([jsonResponse])
            } else {
                setMessageQueue([{"error": "Unable to fetch data."}])
            }
        } catch (err) {
            setMessageQueue([{"error": "Server error. Try again after sometime."}])
        }
    }

    useEffect(async () => {
        await fetchURLsBlacklist()
    }, [])

    return (
        <div>
            <div className="d-flex mb-3 justify-content-between">
                <p className="operation-table">All URLs Blacklist</p>
                <span className="d-flex">
                    <button
                        type="button"
                        className="btn bg--primary text--white px-3 ml-3"
                        onClick={() => history.push(history.location.pathname + '/createURLsBlacklist')}
                    >
                        Create URLs Blacklist
                    </button>
                </span>
            </div>
            <DataTable tableData={{tableHead: pubmaticURLsBlacklistHead, tableBody: URLsBlacklist}}
                       infoHead={true}
                       setMessageQueue={setMessageQueue}/>
        </div>
    )
}

export default PubmaticURLsBlacklist
